import { DisciplinePage } from '../../../shared/components/DisciplinePage';
import { DocumentExplorerPanel } from '../docs/components/DocumentExplorerPanel';
import { FichaCaracterizacion } from '../docs/pages/FichaCaracterizacion';
import { ProcessDashboard } from './ProcessDashboard';
import { AdminProcesosPage } from '../admin/AdminProcesosPage';
import { MadurezProcesoDashboard } from '../maturity/MadurezProcesoDashboard';
import { MadurezPemmProcesoPanel } from '../maturity/MadurezPemmProcesoPanel';
import { MadurezPemmEmpresaPanel } from '../maturity/MadurezPemmEmpresaPanel';
import { useI18n } from '../../../../i18n';

export function ProcessPage() {
  const { t } = useI18n();
  return (
    <DisciplinePage
      accentColor="#0E243E"
      disciplineKey="process"
      disciplineTitle={t.sidebar.pageTitle.process}
      tabs={[
        { key: 'analytics', label: 'Analytics', component: <ProcessDashboard /> },
        {
          key: 'explorador',
          label: t.workspace.exploradorDocumentos,
          component: <DocumentExplorerPanel />,
        },
        {
          key: 'caracterizacion',
          label: t.process.fichaCaracterizacion,
          component: <FichaCaracterizacion />,
        },
        {
          key: 'madurez',
          label:
            (((t.process as Record<string, unknown>)?.madurez as Record<string, unknown>)
              ?.tab as string) ?? 'Madurez',
          component: <MadurezProcesoDashboard embedded />,
        },
        {
          key: 'madurez-pemm',
          label:
            (((t.process as Record<string, unknown>)?.madurezPemm as Record<string, unknown>)
              ?.tab as string) ?? 'Madurez proceso',
          component: <MadurezPemmProcesoPanel />,
        },
        {
          key: 'madurez-empresa',
          label:
            (((t.process as Record<string, unknown>)?.madurezEmpresa as Record<string, unknown>)
              ?.tab as string) ?? 'Madurez empresa',
          component: <MadurezPemmEmpresaPanel />,
        },
        { key: 'admin-procesos', label: t.adminProcesos.pestana, component: <AdminProcesosPage /> },
      ]}
    />
  );
}
